// src/components/Header.js

import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../logoo.png';
import logo2 from '../logoo.png';
import '../css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function Header({ isTransparent = false }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [agenciesDropdownOpen, setAgenciesDropdownOpen] = useState(false);
  const [viewportWidth, setViewportWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();


  const isAdmin = location.pathname.startsWith('/admin');
  const isTemporaryApplication = location.pathname.startsWith('/temporary-application');
  const isPrivacy = location.pathname.startsWith('/privacy');
  const isTerms = location.pathname.startsWith('/terms');

  const isEvents = location.pathname.startsWith('/events');
  const isAlbums = location.pathname.startsWith('/albums');
  const isEventApply = location.pathname.startsWith('/event-apply');

  const forceWhite = isAdmin || isTemporaryApplication || isPrivacy || isTerms || isEvents || isAlbums || isEventApply;
  const isSmallScreen = viewportWidth < 992;


  const toggleNavbar = () => setMenuOpen(!menuOpen);

  const toggleAboutDropdown = () => {
    setAboutDropdownOpen(!aboutDropdownOpen);
    setServicesDropdownOpen(false); // Close Services dropdown
  };

  const toggleServicesDropdown = () => {
    setServicesDropdownOpen(!servicesDropdownOpen);
    setAboutDropdownOpen(false); // Close About Us dropdown
    setAgenciesDropdownOpen(false);
  };

  const toggleAgenciesDropdown = () => {
    setAgenciesDropdownOpen(!agenciesDropdownOpen);
    setAboutDropdownOpen(false);
    setServicesDropdownOpen(false);
  };

  useEffect(() => {
    setMenuOpen(false);
    setAboutDropdownOpen(false);
    setServicesDropdownOpen(false);
    setAgenciesDropdownOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth);
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const headerClass = `modern-header ${forceWhite ? 'header-scrolled' : ''} ${scrolled ? 'header-scrolled' : ''} ${isTransparent ? 'header-transparent' : ''}`;

  return (
    <header className={headerClass}>
      <div className="header-top">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="header-contact">
                <span><i className="fas fa-envelope"></i> info@petrochoice.org</span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="header-social">
                <a href="https://www.linkedin.com/company/petrochoice-integrated-services/posts/?feedView=all" target="_blank"><i className="fab fa-linkedin"></i></a>
                {/* <a href="#"><i className="fab fa-twitter"></i></a> */}
                <a href="https://www.facebook.com/profile.php?id=61552399684686&locale=ar_AR" target="_blank"><i className="fab fa-facebook"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <img
              src={isAdmin || isTemporaryApplication ? logo2 : (isSmallScreen ? logo2 : (isTransparent ? logo : logo))}
              alt="Petro Choice Logo"
              className="logo-img"
            />
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleNavbar}
            aria-controls="navbarNav"
            aria-expanded={menuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink exact="true" to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
                  <i className="fas fa-home"></i>
                  <span>Home</span>
                </NavLink>
              </li>

              <li className="nav-item dropdown mega-dropdown about-us-mega">
                <a
                  href="#"
                  className="nav-link dropdown-toggle"
                  onClick={toggleAboutDropdown}
                >
                  <i className="fas fa-info-circle"></i>
                  <span>About Us</span>
                </a>
                <div className={`dropdown-menu mega-menu ${aboutDropdownOpen ? 'show' : ''}`}>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <h6>Company Information</h6>
                        <ul className="list-unstyled">
                          <li><NavLink to="/about" className="dropdown-item" onClick={() => { setMenuOpen(false); setAboutDropdownOpen(false); }}>About Us</NavLink></li>
                          <li><NavLink to="/mission-vision" className="dropdown-item" onClick={() => { setMenuOpen(false); setAboutDropdownOpen(false); }}>Our Mission & Vision</NavLink></li>
                          <li><NavLink to="/events" className="dropdown-item" onClick={() => { setMenuOpen(false); setAboutDropdownOpen(false); }}>Company Events</NavLink></li>
                          <li><NavLink to="/albums" className="dropdown-item" onClick={() => { setMenuOpen(false); setAboutDropdownOpen(false); }}>Photo Gallery</NavLink></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li className="nav-item dropdown mega-dropdown">
                <a
                  href="#"
                  className="nav-link dropdown-toggle"
                  onClick={toggleServicesDropdown}
                >
                  <i className="fas fa-cogs"></i>
                  <span>Services</span>
                </a>
                <div className={`dropdown-menu mega-menu ${servicesDropdownOpen ? 'show' : ''}`}>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-3">
                        <h6>Integrated Drilling Management Services</h6>
                        <ul className="list-unstyled">
                          <li><NavLink to="/services/integrated-drilling" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>Integrated Drilling</NavLink></li>
                          <li><NavLink to="/services/integrated-drilling/light-wims" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>LD-WIMS</NavLink></li>
                          <li><NavLink to="/services/integrated-drilling/fd-wms" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>FD-WMS <span className="badge bg-warning ms-1">Coming Soon</span></NavLink></li>
                        </ul>
                      </div>

                      <div className="col-md-3">
                        <h6>Technical Services</h6>
                        <ul className="list-unstyled">
                          <li><NavLink to="/services/wellhead" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>Wellhead Services</NavLink></li>
                          <li><NavLink to="/services/manpower" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>Manpower Supply</NavLink></li>
                          <li><NavLink to="/services/mud-services" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>Mud Services</NavLink></li>
                          <li><NavLink to="/services/seismic-acquisition" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>Seismic Acquisition</NavLink></li>
                        </ul>
                      </div>
                      <div className="col-md-3">
                        <h6>Support Services</h6>
                        <ul className="list-unstyled">
                          <li><NavLink to="/services/supply-chain" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>Supply Chain</NavLink></li>
                          <li><NavLink to="/services/ppe" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>PPE - Industrial Coveralls</NavLink></li>
                          <li><NavLink to="/services/inspection" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>Inspection (NDT)</NavLink></li>
                          <li><NavLink to="/services/hse-services" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>HSE Services</NavLink></li>
                        </ul>
                      </div>
                      <div className="col-md-3">
                        <h6>Software Services</h6>
                        <ul className="list-unstyled">
                          <li><NavLink to="/services/software/uniface360" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>Uniface360</NavLink></li>
                          <li><NavLink to="/services/software/npt-break" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>NPT Break</NavLink></li>
                          <li><NavLink to="/services/software/unitrack" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>UniTrack</NavLink></li>
                          <li><NavLink to="/services/software/jms" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>JMS</NavLink></li>
                          <li><NavLink to="/services/petro-talent" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesDropdownOpen(false); }}>PetroTalent</NavLink></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li className="nav-item dropdown">
                <a
                  href="#"
                  className="nav-link dropdown-toggle"
                  onClick={toggleAgenciesDropdown}
                >
                  <i className="fas fa-handshake"></i>
                  <span>Agencies</span>
                </a>
                <div className={`dropdown-menu ${agenciesDropdownOpen ? 'show' : ''}`}>
                  <ul className="list-unstyled mb-0">
                    <li><NavLink to="/agencies/bpm" className="dropdown-item" onClick={() => { setMenuOpen(false); setAgenciesDropdownOpen(false); }}>Beijing Petroleum Machinery (BPM)</NavLink></li>
                    <li><NavLink to="/agencies/kci" className="dropdown-item" onClick={() => { setMenuOpen(false); setAgenciesDropdownOpen(false); }}>Kinetics Controls & Innovation (KCI)</NavLink></li>
                    <li><NavLink to="/agencies/lanzhou-lspe" className="dropdown-item" onClick={() => { setMenuOpen(false); setAgenciesDropdownOpen(false); }}>Lanzhou LS Petroleum Equipment</NavLink></li>
                    <li><NavLink to="/agencies/seismic-acquisition" className="dropdown-item" onClick={() => { setMenuOpen(false); setAgenciesDropdownOpen(false); }}>Split Scientific Company</NavLink></li>
                    <li><NavLink to="/agencies/nnw" className="dropdown-item" onClick={() => { setMenuOpen(false); setAgenciesDropdownOpen(false); }}>NNW Inc.</NavLink></li>
                    <li><NavLink to="/agencies" className="dropdown-item" onClick={() => { setMenuOpen(false); setAgenciesDropdownOpen(false); }}>All Agencies</NavLink></li>
                  </ul>
                </div>
              </li>

              <li className="nav-item">
                <NavLink to="/careers" className="nav-link" onClick={() => setMenuOpen(false)}>
                  <i className="fas fa-briefcase"></i>
                  <span>Careers</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/quote" className="nav-link" onClick={() => setMenuOpen(false)}>
                  <i className="fas fa-calculator"></i>
                  <span>Quote</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/blog" className="nav-link" onClick={() => setMenuOpen(false)}>
                  <i className="fas fa-newspaper"></i>
                  <span>Blogs</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>
                  <i className="fas fa-envelope"></i>
                  <span>Contact</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/news" className="nav-link news-link" onClick={() => setMenuOpen(false)}>
                  <i className="fas fa-rss"></i>
                  <span>News</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header >
  );
}

export default Header;
